import React from 'react';
import { Button } from 'antd';
import Can from 'config/Can';
import useTranslation from 'utils/hooks/useTranslation';
import useFooterPage from './useFooterPage';
import FreezeWalletModal from './FreezeWalletModal';
import CloseWalletModal from './CloseWalletModal';

import styles from './style.module.scss';

const Footer = ({ status, remainingBalance, balanceMajor, currency, onStatusChange }) => {
  const { translateText } = useTranslation();
  const {
    isDetailsOpen,
    isWalletFrozen,
    isWalletClosed,
    isCloseDone,
    isFreezeModalVisible,
    isCloseModalVisible,
    isFreezeLoading,
    isCloseLoading,
    refundNote,
    supportPhoneNumber,
    onToggleDetails,
    onOpenActionModal,
    onCancelFreezeModal,
    onConfirmFreeze,
    onCancelCloseModal,
    onConfirmClose,
    onRefundNoteChange,
  } = useFooterPage({ status, balanceMajor, currency, onStatusChange });

  return (
    <Can I="freeze" a="Wallet" passThrough>
      {canFreeze => (
        <div className={styles.footer} data-testid="walletFooter">
          <div className={styles.footerToggleRow}>
            {translateText('corporateAccounts.wallet.dashboard.footer.title')}{' '}
            <span
              className={styles.footerToggleLink}
              onClick={onToggleDetails}
              data-testid="walletFooterToggle"
            >
              {translateText(
                isDetailsOpen
                  ? 'corporateAccounts.wallet.dashboard.footer.hideDetails'
                  : 'corporateAccounts.wallet.dashboard.footer.moreInformation',
              )}
            </span>
          </div>
          {isDetailsOpen && (
            <div className={styles.footerDetails} data-testid="walletFooterDetails">
              {canFreeze && isWalletClosed && (
                // Closing is final (no reopen in phase 1): nothing left for staff to do here.
                <div className={styles.cardCopy} data-testid="walletFooterClosedCopy">
                  {translateText('corporateAccounts.wallet.dashboard.footer.closedCopy')}
                </div>
              )}
              {canFreeze && !isWalletClosed && (
                <>
                  <div className={styles.cardCopy}>
                    {translateText('corporateAccounts.wallet.dashboard.footer.freeze.copy')}
                  </div>
                  <div>
                    <Button
                      danger
                      onClick={onOpenActionModal}
                      data-testid="walletFooterActionButton"
                    >
                      {translateText(
                        isWalletFrozen
                          ? 'corporateAccounts.wallet.dashboard.footer.close.button'
                          : 'corporateAccounts.wallet.dashboard.footer.freeze.button',
                      )}
                    </Button>
                  </div>
                </>
              )}
              {!canFreeze && (
                <>
                  <div className={styles.cardCopy}>
                    {translateText('corporateAccounts.wallet.dashboard.footer.customerCopy')}
                  </div>
                  <div className={styles.cardCopy} data-testid="walletFooterPhoneNumber">
                    {translateText('corporateAccounts.wallet.dashboard.footer.contactSupport', {
                      phoneNumber: supportPhoneNumber,
                    })}
                  </div>
                </>
              )}
            </div>
          )}
          <FreezeWalletModal
            visible={isFreezeModalVisible}
            isLoading={isFreezeLoading}
            remainingBalance={remainingBalance}
            onCancel={onCancelFreezeModal}
            onConfirm={onConfirmFreeze}
          />
          <CloseWalletModal
            visible={isCloseModalVisible}
            isClosed={isCloseDone}
            isLoading={isCloseLoading}
            refundNote={refundNote}
            onRefundNoteChange={onRefundNoteChange}
            onCancel={onCancelCloseModal}
            onConfirm={onConfirmClose}
          />
        </div>
      )}
    </Can>
  );
};

export default Footer;
